import React from 'react';

import { STEPS } from '../constants';
import CollapsibleSection from './CollapsibleSection/CollapsibleSection';
import GeneralStep from './Steps/GeneralStep';
import PersonalStep from './Steps/PersonalStep';

import moment from 'moment';

export default class AppointmentForm extends React.Component {
    render(props) {
        let viewData = this.props.data;
        let ApplyBtn = this.getApplyBtn.bind(this);
        
        return (<div className="form-wrapper">
            <CollapsibleSection
                isExpanded={this.props.currentStep === STEPS.GENERAL_DETAILS}>

                <GeneralStep
                    hours={viewData.hours}
                    serviceTypes={viewData.serviceTypes}
                    cars={viewData.cars}
                    shouldDisableApptForToday={viewData.shouldDisableApptForToday}
                    shouldDisableApptForNext24Hours={viewData.shouldDisableApptForNext24Hours}
                    sheduleTimes={viewData.sheduleTimes}
                    date={this.props.scheduleDate || moment()}
                    appointmentDetails={this.props.appointmentDetails}
                    setAppointmentState={this.props.setAppointmentState}
                    appointment={this.props.appointment}
                    errors={this.props.generalErrors}
                />
            </CollapsibleSection>

            <CollapsibleSection
                isExpanded={this.props.currentStep === STEPS.PERSONAL_DETAILS}>

                <PersonalStep
                    setAppointmentState={this.props.setAppointmentState}
                    errors={this.props.personalErrors}
                />
            </CollapsibleSection>

            <ApplyBtn />
        </div>);
    }

    getApplyBtn() {
        let text = null;

        switch (this.props.currentStep) {
            case STEPS.GENERAL_DETAILS:
                text = 'Next';
                break;
            case STEPS.PERSONAL_DETAILS:
                text = 'Submit Request';
                break;
            default:
                throw new Error('Invalid step');

        }

        return (<button
            className="apply-btn"
            onClick={() => this.props.moveNext()}>
                {text}
            </button>);
    }
}


// WEBPACK FOOTER //
// ./Src/Appointment/AppointmentScheduler/AppointmentForm/AppointmentForm.jsx